import React, { Component } from 'react'

import API from 'utils/api/api'
import RegionTools from 'utils/regions/regionTools'

import Error from 'components/Error'

class SelectedRegionController extends Component {
  constructor(props) {
    super(props)
    this.state = {
      error: false
    }
  }

  componentDidMount() {
    let selectedRegionCode = this.props.match.params.regionCode
    API.getRegions()
      .then(regions => RegionTools.getDataFromRegions(regions))
      .then(regionsData => {
        let selectedRegionId = RegionTools.getRegionIdFromCode({ regionsData, code: selectedRegionCode })
        this.setSelectedRegionId(selectedRegionId)
      })
      .catch(reason => {
        this.setState({ error: true })
      })
  }

	setSelectedRegionId = id => {
	  this.props.setSelectedRegionId(id)
	}

	renderIfAllOK() {
	  let renderingComponent = null
	  if (this.state.error) {
	    renderingComponent = <Error />
	  } else {
	    renderingComponent = ''
	  }
	  return renderingComponent
	}
	render() {
	  return <React.Fragment>{this.renderIfAllOK()}</React.Fragment>
	}
}

export default SelectedRegionController



// WEBPACK FOOTER //
// ./src/modules/Controllers/SelectedRegion/SelectedRegionController/SelectedRegionController.jsx